import _ from 'lodash';
import { useContext, useMemo } from 'react';
import { FrameworkContext } from '../FrameworkContent';
import { ParentContext } from '../ParentContext';

export const _viewStatusTypes = {
  solo: 'solo',
  list: 'list',
  subList: 'subList'
}

export const useViewItemStatus = ({ uivi, isLongPress = false } = {}) => {

  const frameworkContext = useContext(FrameworkContext)
  const { framework_state } = frameworkContext ?? {}
  const { fw_info } = framework_state ?? {}
  const { view, uivi: viewItemKey, viewKey } = fw_info ?? {}
  const _uivi = uivi || viewItemKey

  const viewItemStatus = useMemo(() => {
    const vis = {
      isViewItemSolo: (view === _uivi) && viewKey ? true : false,
      isViewItemList: (view === _uivi) && !viewKey ? true : false,
      isViewItemSubList: (view !== _uivi) && viewKey ? true : false,
      isLongPress,
      visFor: {
        view,
        viewKey,
        uivi: _uivi
      }
    }
    if (vis.isViewItemList) {
      vis.viewStatusType = _viewStatusTypes.list
    } else if (vis.isViewItemSolo) {
      vis.viewStatusType = _viewStatusTypes.solo
    } else if (vis.isViewItemSubList) {
      vis.viewStatusType = _viewStatusTypes.subList
    }
    return vis
  }, [view, viewKey, viewItemKey, isLongPress, _uivi])
  return viewItemStatus
}
